function capitalizeFirstLetter(string) {
  if (!string || string === undefined || typeof string !== "string") {
    return "-";
  }
  return string[0].toUpperCase() + string.substring(1);
};

export default capitalizeFirstLetter;